import request from '@/utils/request'
import qs from 'qs'
export function chainUploadStatus(data) {
  return request({
    url: `/api/chain/chainUploadStatus?`,
    method: 'post',
    data
  })
}

export function chainThirdChainServerStatus() {
  return request({
    url: `/api/chain/thirdChainServerStatus`,
    method: 'get',
  })
}



